module.exports = __webpack_public_path__ + "static/img/fish38.e16aeee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish38.png
// module id = onyl
// module chunks = 0